import { useI18n } from '../i18n'
import { Meta } from '../components/Meta'
import { QrBuilderPage } from './QrBuilderPage'

export function HomePage() {
  const { t } = useI18n()
  return (
    <>
      <Meta title={t('meta.builder.title')} description={t('meta.builder.description')} path="/create" />
      <QrBuilderPage />
    </>
  )
}
